import { BitkitDialog, BitkitDialogProps } from '@bitrise/bitkit-v2';
import { ReactNode, useState } from 'react';

interface EditDialogProps<T> extends Omit<
  BitkitDialogProps,
  'children' | 'footerButtons' | 'footerContent' | 'onExitComplete' | 'onOpenChange' | 'open'
> {
  children: (edited: T, onClose: () => void) => ReactNode;
  editedValue?: T;
  footerButtons?: (edited: T, onClose: () => void) => ReactNode;
  footerContent?: (edited: T, onClose: () => void) => ReactNode;
  onClose: () => void;
}

const EditDialog = <T,>({
  children,
  editedValue: value,
  footerButtons,
  footerContent,
  onClose,
  ...rest
}: EditDialogProps<T>) => {
  const [closing, setClosing] = useState(false);
  const requestClose = () => setClosing(true);
  return (
    <BitkitDialog
      open={Boolean(value) && !closing}
      onOpenChange={({ open }) => !open && requestClose()}
      onExitComplete={() => {
        onClose();
        setClosing(false);
      }}
      footerButtons={value ? footerButtons?.(value, requestClose) : undefined}
      footerContent={value ? footerContent?.(value, requestClose) : undefined}
      {...rest}
    >
      {value && children(value, requestClose)}
    </BitkitDialog>
  );
};

export default EditDialog;
